<div class="ai-activity-page">
  @if (isLoading()) {
    <div class="policy-spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
  }

  <div class="page-header">
    <div class="subtitle">
      <span [innerHTML]="activitySubtitlePath | labelsProvider"></span>
      <img
        class="icon-field"
        src="assets/images/common/info.svg"
        height="16px"
        [matTooltip]="activityTooltipLabelPath | labelsProvider"
        matTooltipPosition="above"
      />
    </div>
  </div>

  @if (isLoading() === false) {
    <div class="scollable-tables">
      <app-enterprise-ai-activity
        [selectedToggle]="selectedToggle()"
        [option1Text]="option1Text()"
        [option2Text]="option2Text()"
        [option1Icon]="option1Icon()"
        [option2Icon]="option2Icon()"
        (toggleChange)="onToggleChange($event)"
      >
      </app-enterprise-ai-activity>
    </div>
  }
</div>
